import { Components, ThemeProps } from '@powdr/constants';

export const overrides = {
};
